import { Component, ChangeDetectionStrategy } from '@angular/core';

import { Disclaimer } from 'src/config/constants'

@Component({
    selector: 'app-source-of-fund',
    templateUrl: './source-of-fund.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SourceOfFundComponent {
  disclaimerText = Disclaimer;
}
